import React from 'react';
import { Link } from 'react-router-dom';
import { LoadingSpinner } from '../components/LoadingSpinner';

/**
 * Dev / QA: full-screen loader runs indefinitely so animation + copy can be reviewed.
 * Open: /loading-preview
 */
export function LoadingPreviewPage() {
  return (
    <>
      <LoadingSpinner fullScreen />
      <Link
        to="/"
        className="fixed bottom-8 left-1/2 z-[100] -translate-x-1/2 rounded-md bg-gray-900/15 px-3 py-2 text-sm font-medium text-gray-900 backdrop-blur-sm hover:bg-gray-900/25"
      >
        Exit preview
      </Link>
    </>
  );
}
